// Una foto que "vuela" de un lugar a otro de la pantalla — ADR-2026-10-03-redes-editar-vuela-a-la-referencia.
//
// Lo usa "Editar" de la cuadrícula de Redes: la miniatura de la card se achica y viaja
// hasta la tarjeta "Añadir referencia" de la caja, donde va a quedar. Es una copia de la
// imagen montada en el body (`position: fixed`) y animada con la Web Animations API; al
// terminar se borra y la promesa resuelve, que es cuando la pantalla suma el adjunto.
// Con `prefers-reduced-motion`, resuelve al toque sin animar.

export function volarHacia(src: string, desde: DOMRect, hasta: DOMRect, ms = 620): Promise<void> {
  if (typeof window === 'undefined' || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
    return Promise.resolve();
  }
  const img = document.createElement('img');
  img.src = src;
  img.alt = '';
  Object.assign(img.style, {
    position: 'fixed',
    left: `${desde.left}px`,
    top: `${desde.top}px`,
    width: `${desde.width}px`,
    height: `${desde.height}px`,
    objectFit: 'cover',
    borderRadius: '16px',
    zIndex: '300',
    pointerEvents: 'none',
    transformOrigin: 'top left',
    boxShadow: '0 24px 60px -20px rgb(var(--brand-black-rgb) / 0.45)',
  } as Partial<CSSStyleDeclaration>);
  document.body.appendChild(img);
  const escala = Math.min(hasta.width / desde.width, hasta.height / desde.height);
  const dx = hasta.left - desde.left;
  const dy = hasta.top - desde.top;
  const anim = img.animate(
    [
      { transform: 'translate(0px, 0px) scale(1)', opacity: 1 },
      { transform: `translate(${dx * 0.55}px, ${dy * 0.35 - 40}px) scale(${(1 + escala) / 2})`, opacity: 1, offset: 0.5 },
      { transform: `translate(${dx}px, ${dy}px) scale(${escala})`, opacity: 0.85 },
    ],
    { duration: ms, easing: 'cubic-bezier(0.45, 0, 0.2, 1)', fill: 'forwards' },
  );
  return new Promise((resolver) => {
    const fin = () => {
      img.remove();
      resolver();
    };
    anim.onfinish = fin;
    anim.oncancel = fin;
  });
}

/** Un "pop" corto en el destino cuando la foto llega. */
export function latido(el: Element | null): void {
  if (!el || typeof (el as HTMLElement).animate !== 'function') return;
  if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
  (el as HTMLElement).animate(
    [{ transform: 'scale(1)' }, { transform: 'scale(1.04)' }, { transform: 'scale(1)' }],
    { duration: 320, easing: 'ease-out' },
  );
}
